import axios from "./axios";
// import hashPassword from "../utils/security";

async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}


const register = ({ username, password, email }) => {
  return axios.post(
    "/register",
    {
      username,
      password,
      email,
    },
    {
      headers: {
        headers: {
          "Content-Type": "application/json",
        },
      },
    }
  );
};

const login = async({ email, password, isMobile }) => {
  const hashedPassword = await hashPassword(password);
  
  return axios.post(
    "/login",
    {
      email,
      password:hashedPassword,
      isMobile,
    },
    {
      headers: {
        headers: {
          "Content-Type": "application/json",
        },
      },
    }
  );
};

const changePassword = async ({ currentPassword, newPassword }) => {
  const [hashedCurrentPassword, hashedNewPassword] = await Promise.all([
    hashPassword(currentPassword),
    hashPassword(newPassword),
  ]);

  return axios.post("/change_password", {
    current_password: hashedCurrentPassword,
    new_password: hashedNewPassword,
  });
};

export default {
  register,
  login,
  changePassword,
};
